module.exports = __webpack_public_path__ + "static/img/audio.e27d5bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio.jpg
// module id = Ee4l
// module chunks = 49